import { CustomerTypeId } from "interfaces/Mueller.Business.Models.ts";

export const NEW_LENDER = "NEW_LENDER";
export const EXISTING_LENDER = "EXISTING_LENDER";
export const NEW_INSURANCE = "NEW_INSURANCE";
export const EXISTING_INSURANCE = "EXISTING_INSURANCE";

//CustomerTypeEnum 
export const INSURANCE = "Insurance";
export const LENDER = "Lender";
export const BOTH = "Both";

export const CustomerTypeDropdownEntries = [
  { label: "Existing Lender", value: CustomerTypeId.EXISTING_LENDER },
  { label: "Existing Insurance", value: CustomerTypeId.EXISTING_INSURANCE },
  { label: "Existing Loss Draft", value: CustomerTypeId.EXISTING_LOSS_DRAFT },
  { label: "New Lender", value: CustomerTypeId.NEW_LENDER },
  { label: "New Insurance", value: CustomerTypeId.NEW_INSURANCE },
  { label: "New Loss Draft", value: CustomerTypeId.NEW_LOSS_DRAFT },
];